import { track } from "../track";

export const trackGenContentScs = (params: {
  content_id: string;
  length: number;
  gen_time: number;
  gen_price: number;
}) => track({ event: "gen_content_scs", ...params });
